var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fe821b496f387a42ae20a94f3ae84384827d9405"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["busbud-pubweb-prod@busbudcom"]={id:"fe821b496f387a42ae20a94f3ae84384827d9405"};
      